const STORAGE_KEY = 'qihuanmath_config';

const defaultConfig = {
  company: {
    name: '趣味数语探索',
    logo: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=80&h=80&fit=crop',
    slogan: '探索数字之美，点亮好奇之光',
    address: '北京市朝阳区星河路128号',
    phone: '010-8234-5678',
    email: '584834860@qq.com'
  },
  home: {
    banners: [
      {
        id: 1,
        image: 'https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?w=1920&h=600&fit=crop',
        title: '开启数字之旅',
        subtitle: '在探索中遇见数字之美'
      },
      {
        id: 2,
        image: 'https://images.unsplash.com/photo-1596496050827-8299e0220de1?w=1920&h=600&fit=crop',
        title: '点亮逻辑思维',
        subtitle: '在闯关中感受推理的乐趣'
      },
      {
        id: 3,
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=1920&h=600&fit=crop',
        title: '趣味数语探索乐园',
        subtitle: '激发好奇，享受动脑时光'
      }
    ],
    services: [
      {
        id: 1,
        title: '数字启蒙',
        icon: '🔢',
        desc: '在游戏中认识数字与图形，建立数感，享受动脑的乐趣'
      },
      {
        id: 2,
        title: '运算与解谜',
        icon: '➗',
        desc: '在闯关中熟练数字运算，掌握破解情境谜题的思路'
      },
      {
        id: 3,
        title: '逻辑思维',
        icon: '🧩',
        desc: '专注逻辑推理与思维拓展，培养举一反三的思考方式'
      },
      {
        id: 4,
        title: '进阶探索',
        icon: '📐',
        desc: '面向更高阶的符号与图形探索，循序渐进迎接新挑战'
      }
    ],
    team: [
      {
        id: 1,
        name: '邓星辰',
        role: '创始人 / 主理人',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop',
        intro: '二十年数字探索经验，热衷把抽象变得有趣'
      },
      {
        id: 2,
        name: '李知微',
        role: '低龄探索主理',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
        intro: '专注数感启蒙，陪伴上千名小朋友爱上动脑'
      },
      {
        id: 3,
        name: '王子衡',
        role: '进阶探索引路人',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
        intro: '擅长用故事讲透抽象的符号与图形'
      },
      {
        id: 4,
        name: '张牧之',
        role: '挑战内容研究',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop',
        intro: '热爱钻研高难谜题，享受攻克难关的乐趣'
      }
    ],
    news: [
      {
        id: 1,
        title: '春季数字探索主题上新',
        date: '2025-03-01',
        type: '动态'
      },
      {
        id: 2,
        title: '小伙伴们的探索故事分享',
        date: '2025-02-20',
        type: '分享'
      },
      {
        id: 3,
        title: '寒假趣味数字打卡圆满结束',
        date: '2025-02-10',
        type: '活动回顾'
      }
    ]
  },
  about: {
    intro: '趣味数语探索是一个专注「数字思维」与「逻辑探索」的兴趣内容空间。我们相信，数字、图形与逻辑里藏着许多奇妙的乐趣。平台以游戏化、故事化的方式，把抽象的思考变得轻松有趣——通过趣味谜题、逻辑闯关和探索手记，陪伴每一位访客在数字的世界里发现规律、享受动脑的过程。在这里，没有枯燥的灌输，只有好奇心驱动的探索；无论是初识数字的小朋友，还是热爱挑战的思考者，都能找到属于自己的乐趣。我们希望把「理性之美、思考之乐」分享给更多人。',
    philosophy: [
      { title: '思维为本', desc: '探索的根基是思维，我们用科学的方法培养逻辑推理能力' },
      { title: '兴趣引导', desc: '以趣味激发热情，让动脑成为孩子的热爱而非负担' },
      { title: '个性发展', desc: '尊重每个孩子的独特，因势利导，发掘个人潜能' },
      { title: '实践为本', desc: '在动手与闯关中积累，提升真实的思考与应用能力' }
    ]
  },
  products: [
    {
      id: 1,
      category: '启程篇',
      name: '数字启程·初见',
      desc: '认识数字与图形，在游戏里发现规律，悄悄建立数感',
      highlights: ['数字认知', '图形世界', '规律发现', '趣味闯关'],
      goal: '在玩中建立数感，爱上动脑思考',
      image: 'https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?w=400&h=300&fit=crop'
    },
    {
      id: 2,
      category: '进阶篇',
      name: '运算奇旅',
      desc: '在一关关挑战中熟练数字运算，发现巧算背后的规律之美',
      highlights: ['数字运算', '规律探索', '巧算技巧', '思维提速'],
      goal: '提升运算的准确与速度，少出粗心',
      image: 'https://images.unsplash.com/photo-1596496050827-8299e0220de1?w=400&h=300&fit=crop'
    },
    {
      id: 3,
      category: '拓展篇',
      name: '逻辑解谜',
      desc: '用画图与推理破解生活情境里的小谜题，理清复杂头绪',
      highlights: ['情境谜题', '画图法', '逻辑推理', '建模思维'],
      goal: '学会拆解问题，掌握通用的思考路径',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=300&fit=crop'
    },
    {
      id: 4,
      category: '拓展篇',
      name: '思维远征',
      desc: '面向更综合的谜题挑战，锻炼一题多解的灵活思路',
      highlights: ['综合谜题', '逻辑推理', '一题多解', '名题探索'],
      goal: '突破难点，提升综合推理与思考力',
      image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=400&h=300&fit=crop'
    },
    {
      id: 5,
      category: '远征篇',
      name: '符号世界',
      desc: '走进符号与式子的世界，感受用字母表达关系的抽象之美',
      highlights: ['符号思维', '式子变换', '关系探索', '抽象入门'],
      goal: '平稳走进抽象的数字世界，打牢底子',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=300&fit=crop'
    },
    {
      id: 6,
      category: '远征篇',
      name: '图形与变化',
      desc: '探索图形的规律与变化关系，在推理论证中享受发现',
      highlights: ['图形探索', '推理论证', '变化关系', '空间想象'],
      goal: '建立推理论证思维，攻克进阶难点',
      image: 'https://images.unsplash.com/photo-1453906971074-ce568cccbc63?w=400&h=300&fit=crop'
    },
    {
      id: 7,
      category: '远征篇',
      name: '巅峰挑战',
      desc: '综合高难谜题挑战，享受层层攻克难关的成就感',
      highlights: ['综合难题', '高难挑战', '思路梳理', '巅峰探索'],
      goal: '系统梳理思路，挑战高难度谜题',
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=300&fit=crop'
    }
  ],
  solutions: [
    {
      id: 1,
      title: '个性化探索规划',
      icon: '🎯',
      desc: '根据孩子的兴趣与节奏，定制专属的数字探索路线',
      details: ['初次体验，了解起点', '制定个性化探索目标', '定期回顾，灵活调整']
    },
    {
      id: 2,
      title: '三阶递进探索法',
      icon: '📝',
      desc: '认识 — 练手 — 拓展三阶递进，全面提升思考素养',
      details: ['夯实基础概念', '专项动手练手', '思维拓展挑战']
    },
    {
      id: 3,
      title: '小组陪伴探索',
      icon: '👥',
      desc: '小规模分组，确保每位小伙伴都能得到充分关注',
      details: ['小组式陪伴', '互动充分', '耐心细致反馈']
    }
  ],
  cases: [
    {
      id: 1,
      name: '晓柯',
      before: '遇到难题就放弃，容易粗心',
      after: '越难越想挑战，享受解谜',
      desc: '一年的陪伴探索，思考力明显提升'
    },
    {
      id: 2,
      name: '张桦',
      before: '害怕动脑，一遇数字就头疼',
      after: '成了爱钻研的小达人',
      desc: '通过数感启蒙，慢慢爱上了动脑'
    },
    {
      id: 3,
      name: '陈晓彤',
      before: '对数字提不起兴趣',
      after: '主动探索，常有奇思妙想',
      desc: '在持续的探索中实现了转变'
    }
  ],
  contact: {
    address: '福州市仓山区金闽小区三区B区',
    phone: '010-8234-5678',
    mobile: '138-0013-8000',
    wechat: 'shuyuxingqiu',
    email: '584834860@qq.com'
  },
  footer: {
    icp: '闽ICP备2026024311号-1',
    copyright: '趣味数语探索'
  }
};

class ConfigManager {
  constructor() {
    this.config = null;
  }

  loadConfig() {
    if (this.config) return this.config;
    
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        this.config = JSON.parse(stored);
      } else {
        this.config = JSON.parse(JSON.stringify(defaultConfig));
      }
    } catch (e) {
      console.error('加载配置失败:', e);
      this.config = JSON.parse(JSON.stringify(defaultConfig));
    }
    
    return this.config;
  }

  saveConfig(config) {
    try {
      this.config = config;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
      return true;
    } catch (e) {
      console.error('保存配置失败:', e);
      return false;
    }
  }

  resetConfig() {
    this.config = JSON.parse(JSON.stringify(defaultConfig));
    localStorage.removeItem(STORAGE_KEY);
    return this.config;
  }

  exportConfig() {
    return JSON.stringify(this.config, null, 2);
  }

  importConfig(jsonStr) {
    try {
      const imported = JSON.parse(jsonStr);
      this.config = { ...defaultConfig, ...imported };
      this.saveConfig(this.config);
      return true;
    } catch (e) {
      console.error('导入配置失败:', e);
      return false;
    }
  }

  get(key) {
    if (!this.config) this.loadConfig();
    const keys = key.split('.');
    let value = this.config;
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return undefined;
      }
    }
    return value;
  }

  set(key, value) {
    if (!this.config) this.loadConfig();
    const keys = key.split('.');
    const lastKey = keys.pop();
    let obj = this.config;
    for (const k of keys) {
      if (!obj[k]) obj[k] = {};
      obj = obj[k];
    }
    obj[lastKey] = value;
    this.saveConfig(this.config);
  }
}

export default new ConfigManager();
